import React, { Suspense, Fragment, lazy } from 'react';
import { Routes, Navigate, Route } from 'react-router-dom';

import Loader from './components/Loader/Loader';
import AdminLayout from './layouts/AdminLayout';

import GuestGuard from './components/Auth/GuestGuard';
import AuthGuard from './components/Auth/AuthGuard';

import { BASE_URL } from './config/constant';
const renderRoutes = (routes = []) => (
  <Suspense fallback={<Loader />}>
    <Routes>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Element = route.element;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            element={
              <Guard>
                <Layout>{route.routes ? renderRoutes(route.routes) : <Element props={true} />}</Layout>
              </Guard>
            }
          />
        );
      })}
    </Routes>
  </Suspense>
);

export const routes = [
  // {
  //   exact: 'true',
  //   guard: GuestGuard,
  //   path: '/auth/landing',
  //   element: lazy(() => import('./views/landing/Landing'))
  // },
  {
    exact: 'true',
    guard: GuestGuard,
    path: '/auth/signin-2',
    element: lazy(() => import('./views/auth/signin/SignIn2'))
  },
  {
    exact: 'true',
    path: '/404',
    element: lazy(() => import('./views/errors/NotFound404'))
  },
  {
    exact: 'true',
    path: '/maintenance/coming-soon',
    element: lazy(() => import('./views/maintenance/ComingSoon'))
  },
  {
    exact: 'true',
    path: '/maintenance/error',
    element: lazy(() => import('./views/maintenance/Error'))
  },
  {
    exact: 'true',
    path: '/maintenance/offline-ui',
    element: lazy(() => import('./views/maintenance/OfflineUI'))
  },
  {
    exact: 'true',
    path: '/auth/signup-1',
    element: lazy(() => import('./views/auth/signup/SignUp1'))
  },
  {
    exact: 'true',
    path: '/auth/signup-2',
    element: lazy(() => import('./views/auth/signup/SignUp2'))
  },
  {
    exact: 'true',
    path: '/auth/signin-1',
    element: lazy(() => import('./views/auth/signin/SignIn1'))
  },
  {
    exact: 'true',
    path: '/auth/signin-2',
    element: lazy(() => import('./views/auth/signin/SignIn2'))
  },
  {
    exact: 'true',
    path: '/auth/reset-password-1',
    element: lazy(() => import('./views/auth/reset-password/ResetPassword1'))
  },
  {
    exact: 'true',
    path: '/auth/reset-password-2',
    element: lazy(() => import('./views/auth/reset-password/ResetPassword2'))
  },
  {
    exact: 'true',
    path: '/auth/change-password',
    element: lazy(() => import('./views/auth/ChangePassword'))
  },
  {
    exact: 'true',
    path: '/view/otp/:email',
    element: lazy(() => import('./views/auth/reset-password/VerifyOTP'))
  },
  {
    exact: 'true',
    path: '/view/verifypass/:token',
    element: lazy(() => import('./views/auth/reset-password/VerifyPass'))
  },
  {
    exact: 'true',
    path: '/auth/profile-settings',
    element: lazy(() => import('./views/auth/ProfileSettings'))
  },
  {
    exact: 'true',
    guard: AuthGuard,
    path: '/auth/tabs-auth',
    element: lazy(() => import('./views/auth/TabsAuth'))
  },
  {
    path: '*',
    layout: AdminLayout,
    guard: AuthGuard,
    routes: [
      {
        exact: 'true',
        path: '/app/dashboard/analytics',
        element: lazy(() => import('./views/dashboard/DashAnalytics'))
      },
      {
        exact: 'true',
        path: '/customers/customer/:id',
        element: lazy(() => import('./views/customers/CustomerDetails'))
      },
      {
        exact: 'true',
        path: '/customers/customer-list',
        element: lazy(() => import('./views/customers/CustomerList'))
      },
      {
        exact: 'true',
        path: '/customers/insured-list',
        element: lazy(() => import('./views/customers/PaginatedEmpList'))
      },
      // {
      //   exact: 'true',
      //   path: '/users/user-list',
      //   element: lazy(() => import('./views/users/UserList'))
      // },

      // {
      //   exact: 'true',
      //   path: '/pdfviewer/pdfviewer-list/:id',
      //   element: lazy(() => import('./views/pdfviewer/PdfViewer'))
      // },
      {
        exact: 'true',
        path: '/leave/leave-entry',
        element: lazy(() => import('./views/leave/LeaveEntry'))
      },
      {
        exact: 'true',
        path: '/leave/leave-approval',
        element: lazy(() => import('./views/leave/LeaveApproval'))
      },
      {
        exact: 'true',
        path: '/leave/leave-details/:id',
        element: lazy(() => import('./views/leave/LeaveDetails'))
      },
      {
        exact: 'true',
        path: '/leave/leave-dash',
        element: lazy(() => import('./views/leave/LeaveDashboard'))
      },
      {
        exact: 'true',
        path: '/leave/departmental-admin',
        element: lazy(() => import('./views/leave/DepartmentalAdmin'))
      },
      {
        exact: 'true',
        path: '/leave/employee-pay-setup',
        element: lazy(() => import('./views/leave/EmployeePaySetup'))
      },
      {
        exact: 'true',
        path: '/leave/monthly-payroll-processing',
        element: lazy(() => import('./views/leave/MonthlyPayrollProcessing'))
      },
      {
        exact: 'true',
        path: '/leave/leave-approvalssp',
        element: lazy(() => import('./views/leave/LeaveApprovalssp'))
      },
      {
        exact: 'true',
        path: '/leave/leave-management',
        element: lazy(() => import('./views/leave/LeaveManagement'))
      },
      {
        exact: 'true',
        path: '/leave/pay-report',
        element: lazy(() => import('./views/leave/PayReports'))
      },
      {
        exact: 'true',
        path: '/leave/tasks-appraisals',
        element: lazy(() => import('./views/leave/TasksAndAppraisals'))
      },
      {
        exact: 'true',
        path: '/leave/hdesk',
        element: lazy(() => import('./views/leave/HelpDesk'))
      },
      {
        exact: 'true',
        path: '/requisitions/store',
        element: lazy(() => import('./views/store/Requisitions'))
      },
      {
        exact: 'true',
        path: '/requisitions/admin',
        element: lazy(() => import('./views/store/Requisitionsadmin'))
      },
      {
        exact: 'true',
        path: '/recruitment/careers',
        element: lazy(() => import('./views/recruitment/InterviewHeaders'))
      },
      {
        exact: 'true',
        path: '/recruitment/app-profile',
        element: lazy(() => import('./views/recruitment/ApplicantProfile'))
      },
      {
        exact: 'true',
        path: '/recruitment/interview',
        element: lazy(() => import('./views/store/Requisitionsadmin'))
      },
      {
        exact: 'true',
        path: '/payroll/payroll-setup',
        element: lazy(() => import('./views/leave/EmployeePayParams'))
      },
      {
        exact: 'true',
        path: '/payroll/monthly-periods',
        element: lazy(() => import('./views/hr/HrMonths'))
      },
      {
        exact: "true",
        path: "/cmp/comp-dash",
        element: lazy(() => import("./views/hr/CompanyDash")),
      },
      {
        exact: "true",
        path: "/financials/banks",
        element: lazy(() => import("./views/hr/Banks")),
      },
      {
        exact: 'true',
        path: '/leave/monthly-earnings-deductions',
        element: lazy(() => import('./views/leave/MonthlyEarningsDeducitons'))
      },
      {
        exact: "true",
        path: "/hr/reports",
        element: lazy(() => import("./views/hr/Reports")),
      },
      {
        path: '*',
        exact: 'true',
        element: () => <Navigate to={BASE_URL} />
      }
    ]
  }
];

export default renderRoutes;
